import React from 'react';
import moment from 'moment';

import { withStyles } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import styles from '../../FundOverview/Item/styles';
import icons from '../../../images';
import { formatToGerman } from '../../../utils/backtestOverviewUtils';
import { BACKTEST_STATUS } from '../../../containers/BacktestOverview/constants';

export default withStyles(styles)((props) => {
  const { classes, fund } = props;
  return (
    <React.Fragment>
      <TableRow className={classes.fundValues}>
          <TableCell style={{paddingLeft: 0}}>{fund.date ? moment(fund.date).format('DD.MM.YY') : '-'}</TableCell>
        <TableCell>{formatToGerman(fund.perf_1d)}</TableCell>
        <TableCell>{formatToGerman(fund.perf_mtd)}</TableCell>
        <TableCell>{formatToGerman(fund.perf_ytd)}</TableCell>
        <TableCell>{formatToGerman(fund.perf_pa)}</TableCell>
        <TableCell>{formatToGerman(fund.is_stocks)}</TableCell>
        <TableCell>{formatToGerman(fund.is_bonds)}</TableCell>
        <TableCell>{formatToGerman(fund.is_cash)}</TableCell>
        {(fund.backtest.bt_id &&fund.backtest.calculation) ? (
          <React.Fragment>
            {fund.backtest.calculation.status === BACKTEST_STATUS.SUCCESS ? (
              <React.Fragment>
                <TableCell className={classes.displayOnHover} style={{maxWidth: 120}}>
                  {formatToGerman(fund.should_stocks)}
                  <span>
                    <React.Fragment>
                      ({fund.should_stocks_diff > 0 ? '+' : ''}
                      {formatToGerman(fund.should_stocks_diff)})
                    </React.Fragment>
                  </span>
                  {fund.should_stocks_diff && fund.should_stocks_diff !== 0 ? (
                    <img src={fund.should_stocks_diff < 0 ? icons.icons.decrease_arrow : icons.icons.increase_arrow} alt="decrease"/>
                    ) : (<span />)}
                </TableCell>
                <TableCell className={classes.displayOnHover} style={{maxWidth: 120}}>
                  {formatToGerman(fund.should_bonds)}
                  <span>
                    <React.Fragment>
                      ({fund.should_bonds_diff > 0 ? '+' : ''}
                      {formatToGerman(fund.should_bonds_diff)})
                    </React.Fragment>
                  </span>
                  {fund.should_bonds_diff && fund.should_bonds_diff !== 0 ? (
                    <img src={fund.should_bonds_diff < 0 ? icons.icons.decrease_arrow : icons.icons.increase_arrow} alt="decrease"/>
                    ) : (<span />)}
                </TableCell>
                <TableCell className={classes.displayOnHover} style={{maxWidth: 120}}>
                  {formatToGerman(fund.should_cash)}
                  <span>
                    <React.Fragment>
                      ({fund.should_cash_diff > 0 ? '+' : ''}
                      {formatToGerman(fund.should_cash_diff)})
                    </React.Fragment>
                  </span>
                  {fund.should_cash_diff && fund.should_cash_diff !== 0 ? (
                    <img src={fund.should_cash_diff < 0 ? icons.icons.decrease_arrow : icons.icons.increase_arrow} alt="decrease"/>
                    ) : (<span />)}
                </TableCell>
                <TableCell>{formatToGerman(fund.trade_stocks_perc)}</TableCell>
                <TableCell>{formatToGerman(fund.trade_bonds_perc)}</TableCell>
                <TableCell>{formatToGerman(fund.trade_cash_perc)}</TableCell>
                <TableCell>{formatToGerman(fund.risk_budget)}</TableCell>
                <TableCell>{formatToGerman(fund.on_risk_total)}</TableCell>
                <TableCell>{formatToGerman(fund.on_risk_eq)}</TableCell>
                <TableCell>{formatToGerman(fund.on_risk_fi)}</TableCell>
                <TableCell>{formatToGerman(fund.lpm0)}</TableCell>
              </React.Fragment>
            ) : (
              <TableCell colSpan={9} />
            )}
          </React.Fragment>
        ) : (
          <TableCell colSpan={9} />
        )}
      </TableRow>
      <TableRow className={classes.additionalInfoColumns}>
      <TableCell colSpan={7} />
        <TableCell colSpan={3}>
          <span
            className={
              [
                classes.statusText, 
                (fund.backtest.calculation && fund.backtest.calculation.status === 2) ?  classes.calculationErrorText : ''
              ].join(' ')}
          >
          <b>Calculated:</b>
          <React.Fragment>
            {
              (fund.backtest.bt_id && fund.backtest.calculation) && (
                <React.Fragment>
                  { (fund.backtest.calculation.status !== 3 && fund.backtest.calculation.status !== 4) ? (
                    <React.Fragment>
                      { fund.backtest.calculation.status === 2 ? (
                        <span> Calculation error</span>
                      ) : (
                        <React.Fragment>
                          { moment(fund.backtest.overview.calculated).format('DD.MM.YYYY - HH.mm')}
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : (<span />)}
                </React.Fragment>
              )
            }
          </React.Fragment>
          </span>
        </TableCell>
        <TableCell colSpan={9} />
      </TableRow>
    </React.Fragment>
  )
})